import messageService from './messageService'

export default messageService






// WEBPACK FOOTER //
// ../src/services/messageService/index.js